const staticContent = ['telefonisch', 'E-Mail', 'Brief', 'persönlich', 'Webkonferenz', 'LinkedIn', 'Xing'];
module.exports = staticContent;
